import { formatRequest } from "../../utils/function";
import axiosInstance from "../axiosInstance";

export function getAllConfigsList() {
  return axiosInstance.get(`/configs`);
}

export function getAllCardsList() {
  return axiosInstance.get(`/cards/all-list`);
}

export function getAllRewardProgramsList() {
  return axiosInstance.get(`/reward-programs/all-list`);
}


